import { createAction } from '@reduxjs/toolkit';
import { ICourseOut } from 'types/domain/course';
import { IModuleOut } from 'types/domain/module';
import { INode } from 'types/domain/base';
import { IStructureOut } from 'types/domain/structure';
import { EntityTypes } from '../../../constants/entities';
import { LinkTypes } from '../../../constants/links';
import { IUpdate } from './data';
import { ScormVersion } from 'utils/scormManifest';

export interface IMove {
  items?: IMoveItem[];
  parentEntityType: EntityTypes;
  parentEntityId: number;
  offset?: INode;
  nodes?: INode[];
}

export interface IMoveItem {
  id: number;
  type: EntityTypes;
  node?: INode;
  order?: number;
}

export interface ICopy {
  items: ICopyItem[];
  parentEntityType: EntityTypes;
  parentEntityId: number;
  targetEntityId: number;
  offset?: INode;
}

export interface ICopyItem {
  offlineId: number;
  id: number;
  type: EntityTypes;
  node: INode;
  parentEntityType?: EntityTypes;
}

export interface ICopyResponse {
  items: any[];
}

export interface ILink {
  offlineId: number;
  type: LinkTypes;
  parentEntityId: number;
  parentEntityOfflineId: number;
  parentEntityType: EntityTypes;
  port: string; // i.e. failOutId, progressOutId
  childEntityId: number;
  childEntityOfflineId: number;
  childEntityType: EntityTypes;
}

export interface ILinkResponse {
  type: LinkTypes;
  out: ICourseOut | IModuleOut | IStructureOut;
  parentEntityType: EntityTypes;
  parentEntity: any;
}

export interface ILinkAction {
  data: any;
}

export interface IQR {
  courseNodeId: number;
  logo?: boolean;
  image?: boolean;
}

export interface ISCORM {
  courseNodeId: number;
  token: string;
  embed?: boolean;
  /** Which data model the package declares; the runtime follows whichever API the LMS exposes. */
  version?: ScormVersion;
  /** The name the LMS lists the package under. */
  title?: string;
}

export interface IReset {
  ids: number[];
  parentEntityType: EntityTypes;
  parentEntityId: number;
}

export const move = createAction('admin/move', function prepare(entity: IMove) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const reset = createAction('admin/reset', function prepare(entity: IReset) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const copy = createAction('admin/copy', function prepare(entity: ICopy) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const link = createAction('admin/link', function prepare(entity: IUpdate) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const deleteLink = createAction('admin/link/delete', function prepare(entity: IUpdate) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const addLinkAction = createAction('admin/link/add/action', function prepare(entity: ILinkAction) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const generateQRCode = createAction('admin/generateQRcode', function prepare(entity: IQR) {
  return {
    payload: {
      ...entity,
    },
  };
});

export const downloadSCORM = createAction('admin/downloadSCORM', function prepare(entity: ISCORM) {
  return {
    payload: {
      ...entity,
    },
  };
});
